import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/settings/company_settings/Page";

export const PATH = "/settings/company_settings";

const Home: NextPage = () => (
	<>
		<NskHead title="会社情報設定" />
		<Component />
	</>
);

export default Home;
